import removeAntiHijackingSequence from './remove-json-anti-hijacking-sequence';
import getResponseError from './get-response-error';
import WaFetchError from './wa-fetch-error';

export default convert =>
  async (response) =>
  {
    let error;

    try
    {
      const responseText = await response.text();
      const antiHijackedResponseText = removeAntiHijackingSequence(responseText);

      if (response.ok)
      {
        return convert(antiHijackedResponseText);
      }

      const { message, responseJSON } = getResponseError(antiHijackedResponseText);

      error = new WaFetchError(message);
      error.response = response;
      error.responseJSON = responseJSON;
    }
    catch (err)
    {
      error = err;
    }

    throw error;
  };
